<template>
    <v-container
        :id="
            section.columnId && section.columnId[$i18n.locale]
                ? section.columnId[$i18n.locale].current
                : section._key
        "
        :class="
            `heading-blurb-separator${
                section.dense ? ' py-0' : ''
            } text-${calcAlign(section.textAlign, 'center')}`
        "
    >
        <v-row column justify-center align-center>
            <v-col
                v-if="section.heading && section.heading[$i18n.locale]"
                cols="12"
                class="col--hbs"
            >
                <component
                    :is="calcMarkup(section.headingMarkup, 'h2')"
                    :class="
                        `${calcUppercase(
                            section.headingUppercase,
                            ''
                        )} text-${calcAlign(
                            section.textAlign,
                            'center'
                        )} font-${calcFontSize(section.headingSize, '')}`
                    "
                    :style="
                        `color:${calcColor(section.fontColor, colors.graphite)}`
                    "
                    >{{ section.heading[$i18n.locale] }}</component
                >
                <!-- <h2
                    :class="
                        `${
                            section.headingUppercase ? 'uppercase ' : ''
                        }text-${calcAlign(section.textAlign, 'center')}`
                    "
                    :style="`color:${calcColor(section.fontColor, '#ffffff')}`"
                >
                    {{ section.heading[$i18n.locale] }}
                </h2> -->
            </v-col>
            <v-col
                v-if="section.blurbage && section.blurbage[$i18n.locale]"
                cols="12"
            >
                <div
                    :class="
                        `hbs-blurb font-regular text-${calcAlign(
                            section.textAlign,
                            'center'
                        )}`
                    "
                    :style="
                        `color:${calcColor(
                            section.fontColor,
                            colors.graphite
                        )};`
                    "
                >
                    <BlockContent :blocks="section.blurbage[$i18n.locale]" />
                </div>
            </v-col>
            <v-col v-if="section.separator !== 'none'" cols="12">
                <div>
                    <Separator
                        :steez="section.separator"
                        :align="section.textAlign"
                        :color="calcColor(section.fontColor, colors.primary)"
                    />
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import Separator from '~/components/Separator'
import alignUtilities from '~/mixins/alignUtilities'
import colorUtilities from '~/mixins/colorUtilities'
import textUtilities from '~/mixins/textUtilities'

export default {
    name: 'HeadingBlurbSeparator',
    components: {
        Separator
    },
    mixins: [alignUtilities, colorUtilities, textUtilities],
    props: {
        section: {
            type: Object,
            default: null
        }
    },
    computed: {
        isUppercase() {
            return this.section.headingUppercase
        }
    }
}
</script>
